import { render, staticRenderFns } from "./NavbarButtonNotification.vue?vue&type=template&id=81f629ce&scoped=true"
import script from "./NavbarButtonNotification.vue?vue&type=script&lang=js"
export * from "./NavbarButtonNotification.vue?vue&type=script&lang=js"
import style0 from "./NavbarButtonNotification.vue?vue&type=style&index=0&id=81f629ce&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f629ce",
  null
  
)

export default component.exports